import Toggle from "../../../../Atoms/Toggle";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import './styles.css';

export default function GuidingQuestionCard({ 
    question, 
    isActive = false, 
    onToggle, 
    onEdit,
    onDelete,
    disabled = false,
    className = ""
}) {
    const handleToggle = (checked) => {
        if (onToggle) {
            onToggle(question.id, checked);
        }
    };

    const handleEdit = (e) => {
        e.stopPropagation();
        if (!disabled && onEdit) {
            onEdit(question.id);
        }
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        if (!disabled && onDelete) {
            onDelete(question.id);
        }
    };

    return (
        <div className="guiding-question-card-wrapper">
            <div className={`guiding-question-card ${isActive ? 'active' : ''} ${disabled ? 'disabled' : ''} ${className}`}>
                <div className="guiding-question-content">
                    <p className="guiding-question-text">{question.text}</p>
                </div>
                <div className="guiding-question-toggle">
                    <Toggle
                        checked={isActive}
                        onChange={handleToggle}
                        disabled={disabled}
                        size="medium"
                    />
                </div>
            </div>
            
            <div className="guiding-question-actions">
                <button
                    className="guiding-question-action-btn guiding-question-edit-btn"
                    onClick={handleEdit}
                    title="Editar pergunta norteadora"
                    aria-label="Editar pergunta norteadora"
                >
                    <FaRegEdit size={14} />
                </button>
                <button
                    className="guiding-question-action-btn guiding-question-delete-btn"
                    onClick={handleDelete}
                    title="Excluir pergunta norteadora"
                    aria-label="Excluir pergunta norteadora"
                >
                    <FaTrash size={14} />
                </button>
            </div>
        </div>
    );
}